import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import classnames from 'classnames';
import hljs from 'highlight.js';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import "./hljs.css";
import "./index.css";
import "./markdown.css";
hljs.configure({
  classPrefix: '',
  // don't append class prefix
  tabReplace: '  ' // 2 spaces

});

var PreviewMarkdown = /*#__PURE__*/function (_React$Component) {
  _inherits(PreviewMarkdown, _React$Component);

  var _super = _createSuper(PreviewMarkdown);

  function PreviewMarkdown(props) {
    var _this;

    _classCallCheck(this, PreviewMarkdown);

    _this = _super.call(this, props);
    _this.node = void 0;

    _this.allowNode = function (node) {
      if (node.type === 'html' && node.value) {
        if (/<!--([^]+?)-->/.test(node.value)) {
          return false;
        }
      }

      return true;
    };

    _this.state = {
      value: props.value,
      visible: props.visible
    };
    return _this;
  }

  _createClass(PreviewMarkdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.highlight();
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        visible: true
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "highlight",
    value: function highlight() {
      var code = this.node.getElementsByTagName('code');

      var _iterator = _createForOfIteratorHelper(code),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          var tag = value.parentNode;

          if (tag && tag.tagName === 'PRE') {
            hljs.highlightBlock(value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "updateSource",
    value: function updateSource(value) {
      var _this2 = this;

      this.setState({
        value: value
      }, function () {
        _this2.highlight();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          visible = _this$props.visible,
          value = _this$props.value,
          previewProps = _this$props.previewProps,
          elementProps = _objectWithoutProperties(_this$props, ["prefixCls", "visible", "value", "previewProps"]);

      return /*#__PURE__*/React.createElement("div", _extends({
        ref: function ref(node) {
          return _this3.node = node;
        },
        className: classnames("".concat(prefixCls, "-preview"), _defineProperty({}, "".concat(prefixCls, "-visible"), this.state.visible))
      }, elementProps), /*#__PURE__*/React.createElement(ReactMarkdown, _extends({
        className: classnames("".concat(prefixCls, "-markdown")),
        source: this.state.value,
        escapeHtml: false,
        allowNode: this.allowNode
      }, previewProps)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.value !== state.value) {
        return {
          value: props.value
        };
      }

      return null;
    }
  }]);

  return PreviewMarkdown;
}(React.Component);

PreviewMarkdown.defaultProps = {
  prefixCls: 'md-editor',
  visible: true
};
export { PreviewMarkdown as default }; 
//# sourceMappingURL=index.js.map